/**
 * @license
 *-------------------------------------------------------------------------------------------
 * Copyright © 2025 Progress Software Corporation. All rights reserved.
 * Licensed under commercial license. See LICENSE.md in the package root for more information
 *-------------------------------------------------------------------------------------------
 */
"use client";
import * as t from "react";
import { GridSelectionCellInput as p } from "./GridSelectionCellInput.mjs";
import { getSelectionCellTdProps as m, getCustomCell as i } from "./utils.mjs";
import { useLegacyCellProps as C } from "../hooks.mjs";
import { useSelectionCellClientTdProps as d } from "./useSelectionCellClientTdProps.mjs";
const g = (c) => {
  const { cellProps: e } = c, { tdProps: o } = m(e), r = d(e), s = C(e), l = /* @__PURE__ */ t.createElement(p, { key: 1, ...e }), n = i(e);
  return n ? /* @__PURE__ */ t.createElement(n, { ...e, ...s, tdProps: { ...o, ...r } }, l) : e.rowType !== "groupHeader" ? /* @__PURE__ */ t.createElement("td", { ...o, ...r }, l) : null;
};
export {
  g as GridSelectionCell
};
